import {
    SET_USER_ANALYSIS
} from "../mutations";
import {
    FETCH_USER_ANALYSIS,
} from "../actions";
import {AccountService} from "../../common/api.service";

const state = {
    analysis_list: []
}

const mutations = {
    [SET_USER_ANALYSIS]: (state, payload) => {
        state.analysis_list = payload
    }
}

const getters = {
    analysis_list(state) {
        return state.analysis_list;
    }
}

const actions = {
    [FETCH_USER_ANALYSIS](context, payload) {
        return AccountService.getUserAnalysisList().then(
            function (response) {
                context.commit(SET_USER_ANALYSIS, response.data);
            });
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/account.js